import { WebViewerInstance } from '@pdftron/webviewer';
import { Layer } from 'types';
import { getUpdatedLayerContextForWebviewer } from 'utils/layerUtils';
import { redrawAll } from 'pdftron/utils/renderUtils';

class Layers {
  instance: WebViewerInstance;

  constructor(instance: WebViewerInstance) {
    this.instance = instance;
  }

  /**
   * Applies layer visibility to the document.
   *
   * @param options.skipRefresh When true, updates the layer context but does not refresh the
   * viewer. Used on document load, where separation and layer visibility are applied together and
   * a single caller-owned refresh renders both instead of two full-cache invalidations.
   * @returns A promise that resolves once the layer context has been applied.
   */
  refreshLayerView = (layers: Layer[], options?: { skipRefresh?: boolean }): Promise<void> => {
    const docViewer = this.instance.Core.documentViewer;
    if (!docViewer) return Promise.resolve();

    const doc = docViewer.getDocument();

    return Promise.resolve(doc.getLayersArray()).then((docLayers) => {
      const updatedLayers = getUpdatedLayerContextForWebviewer(docLayers, layers);
      doc.setLayersArray(updatedLayers);
      if (!options?.skipRefresh) {
        redrawAll(docViewer);
      }
    });
  };
}
export default Layers;
